import { action } from "typesafe-actions";
import { AuthActionTypes } from "./auth.model";

export const loginUserRequest = (req) => action(AuthActionTypes.LOGIN_USER_REQUEST, req);
export const loginUserSuccess = (res) => action(AuthActionTypes.LOGIN_USER_SUCCESS, res);
export const loginUserFailure = (err) => action(AuthActionTypes.LOGIN_USER_FAILURE, err);
